export default theme => ({
  root: {},
  formModal: {
    paddingBottom: 20
  },
  formModalOverlay: {
    zIndex: 1100
  },
  confirmModalOverlay: {
    zIndex: 1100
  },
  signatureOverlay: {
    zIndex: 1100
  },
  loaderContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  loader: {
    margin: '0 auto'
  },
  error: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center'
  },
  errorIcon: {
    width: 32,
    height: 32,
    margin: '0 auto 5px'
  },
  errorText: {
    display: 'block',
    color: theme.colors.utility.textSecondary,
    textAlign: 'center'
  },
  noForms: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center'
  },
  noFormsIcon: {
    width: 32,
    height: 32,
    margin: '0 auto'
  },
  noFormsText: {
    display: 'block',
    color: theme.colors.utility.textSecondary,
    textAlign: 'center'
  }
});